import React from 'react';
import { Line, Box, Header, Text, Icons, variables } from '@generationtux/component-library';
import { scrollTop } from '../../../utils/utils';
import { useSpring, animated } from 'react-spring';
import SaveBox from '../SaveBox';
import styled from 'styled-components';

const BoxLink = styled(Box)`
  cursor: pointer;
  &:hover {
    div:last-child {
      color: ${props => variables(props).textPrimary};
      polygon {
        fill: ${props => variables(props).textPrimary};
      }
      line {
        stroke: ${props => variables(props).textPrimary};
      }
    }
  }
`;

const GalleryDetails = ({
  selectedCatalogNumbers,
  setActiveCollection,
  docBrownsTimeMachine,
  activeCollection,
  setProductDetails,
  productDetails,
  selected,
  undo,
}) => {
  const { product, isBundle } = productDetails;
  const name = isBundle ? product.displayName : product.catalogName;
  const media = product.media;
  const description = isBundle ? product.shortDescription : product.description;
  const animationProps = useSpring({ opacity: 1, from: { opacity: 0 } });

  return (
    <animated.div style={animationProps}>
      <Box style={{ maxWidth: 800 }}>
        <Box>
          <BoxLink
            backgroundColor="white"
            p={3}
            mb={1}
            display="flex"
            justifyContent="space-between"
            onClick={() => {
              scrollTop();
              setProductDetails(null);
            }}
          >
            <Header type={5}>{name}</Header>
            <Box display="flex" alignItems="center">
              <Icons.ArrowLeft mr={2} /> <Text size="xs">Back</Text>
            </Box>
          </BoxLink>

          <Box backgroundColor="white" style={{ position: 'relative' }}>
            {media
              .filter(image => image.label.includes('PDP'))
              .map(image => (
                <img
                  key={image.url}
                  style={{ display: 'block' }}
                  alt={`${name} ${image.label}`}
                  src={`${image.url}?auto=format&fit=crop&fm=jpg&q=75&w=800`}
                />
              ))}
          </Box>
          <Box backgroundColor="white" mt={1} px={4} py={5}>
            <Header type={3} headline>
              {name}
            </Header>
            <Line headlineDivider />
            <Text style={{ maxWidth: '37em' }}>{description}</Text>
          </Box>
        </Box>

        <SaveBox
          productDetails={productDetails}
          setProductDetails={setProductDetails}
          activeCollection={activeCollection}
          setActiveCollection={setActiveCollection}
          selectedCatalogNumbers={selectedCatalogNumbers}
          docBrownsTimeMachine={docBrownsTimeMachine}
          selected={selected}
          undo={undo}
        />
      </Box>
    </animated.div>
  );
};

export default GalleryDetails;
